/* eslint-disable max-len */
import digitalData from 'digital-data';
import { ERROR } from '../../components/constants';

export const authorizeCardRemotePurchases = () => {
  const trackEvent = (event) => {
    digitalData.event = digitalData.event || [];
    digitalData.event.push(event);
  };

  const actions = { 
    pageLoaded: () => {
      const thdAnalyticsEvent = {
        category: {
          primaryCategory: 'overlay'
        },
        eventInfo: {
          eventName: 'authorize card for remote purchases'
        },
      };
      trackEvent(thdAnalyticsEvent);
    }, 

    buttonSubmission: ({ output }) => {
      const { section, actionType } = output || {};
      const thdAnalyticsEvent = {
        category: {
          primaryCategory: 'button submission'
        },
        eventInfo: {
          eventName: 'my account settings'
        },
        myAccount: {
          settings: `cards and accounts: ${section}: ${actionType}`
        },
      };
      trackEvent(thdAnalyticsEvent);
    },

    postPageErrors: ({ output }) => {
          const {
            type, displayType, pageSection, message, code = 'n/a'
          } = output || {};
          const DDOEvent = {
            category: {
              primaryCategory: ERROR,
            },
            eventInfo: {
              eventName: 'post page error',
              error: [
                {
                  type,
                  displayType,
                  pageSection,
                  message,
                  code,
                },
              ],
            },
          };
          trackEvent(DDOEvent);
        },
  };

  window.LIFE_CYCLE_EVENT_BUS.on('authorize-card-remote-purchases', actions.pageLoaded);
  window.LIFE_CYCLE_EVENT_BUS.on('authorize-card-remote-purchases.button-submission', actions.buttonSubmission);
  window.LIFE_CYCLE_EVENT_BUS.on('cc-remote-purchases.post-page-error', actions.postPageErrors);
  window.LIFE_CYCLE_EVENT_BUS.on('ptc-remote-purchases.post-page-error', actions.
    postPageErrors);
};
